exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2xRN7SyYNvRR0LxwQ2-_RP{width:420px;height:269px;background-color:#fff;border-radius:2px;color:#2a2a2a;font-size:15px;line-height:22px;font-weight:400}._2wwyg70-oJL4qkvNkPZI8Z{padding:30px 156px 6px 156px}._3rSho3ztNwX0K1eaHy-h-L{box-sizing:border-box;height:2px;width:100%;border:1px solid #bdbdbd;margin-bottom:29px}._1UO-WJqOpgXJ_bllir5tJ0{margin:29px 50px 30px 50px}._3Mn6UDGGNmsRvMrqNUlgrC{margin:0 50px 40px 50px}\n", ""]);

// Exports
exports.locals = {
	"PaymentSuccess": "_2xRN7SyYNvRR0LxwQ2-_RP",
	"withPadding": "_2wwyg70-oJL4qkvNkPZI8Z",
	"line": "_3rSho3ztNwX0K1eaHy-h-L",
	"next": "_1UO-WJqOpgXJ_bllir5tJ0",
	"toProfile": "_3Mn6UDGGNmsRvMrqNUlgrC"
};